import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

const TYPE_COLORS = {
  income: "text-emerald-700 bg-emerald-50 border-emerald-200",
  expense: "text-rose-700 bg-rose-50 border-rose-200",
  asset: "text-blue-700 bg-blue-50 border-blue-200",
  liability: "text-amber-700 bg-amber-50 border-amber-200",
  equity: "text-purple-700 bg-purple-50 border-purple-200",
};

export default function ChartOfAccounts() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/chart-of-accounts").then((r) => setRows(r.data)); }, []);

  const grouped = rows.reduce((acc, r) => {
    acc[r.type] = acc[r.type] || [];
    acc[r.type].push(r);
    return acc;
  }, {});

  const order = ["asset", "liability", "equity", "income", "expense"];

  return (
    <div className="space-y-5 lb-fade" data-testid="coa-page">
      <div>
        <div className="text-[11px] uppercase tracking-widest text-neutral-500 font-semibold">Setup</div>
        <h1 className="font-display font-extrabold text-3xl tracking-tight">Chart of Accounts</h1>
        <p className="text-neutral-600 text-sm mt-1">The ledger accounts driving every double-entry voucher.</p>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        {order.filter((t) => grouped[t]).map((type) => (
          <div key={type} className="lb-card p-5">
            <div className="flex items-center justify-between mb-3">
              <div className="font-display font-bold text-lg capitalize">{type}s</div>
              <span className={"lb-badge " + TYPE_COLORS[type]}>{grouped[type].length}</span>
            </div>
            <ul className="space-y-1">
              {grouped[type].map((a) => (
                <li key={a.id || a.name} className="flex items-center justify-between border-b border-neutral-100 py-2">
                  <div>
                    <div className="font-semibold text-sm">{a.name}</div>
                    <div className="text-xs text-neutral-500">{a.group}</div>
                  </div>
                  {a.system && <span className="text-[10px] text-neutral-400 uppercase tracking-wider">System</span>}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
